import React, { useCallback, useContext, useEffect, useState } from 'react'
import { createGenerationRequest } from 'api'
import pollRequest from 'api/pollRequest'
import Container from 'components/common/Container'
import IdleStage from 'components/stages/generation/IdleStage'
import ProcessingStage from 'components/stages/generation/ProcessingStage'
import FinishStage from 'components/stages/generation/FinishStage'
import MainLayoutContext from 'contexts/MainLayoutContext'
import c from './GenerationPage.module.scss'

function GenerationPage() {
  const {
    stage,
    setStage,
    deviceId,
    processedImageUrl,
    setProcessedImageUrl,
    user,
  } = useContext(MainLayoutContext)

  const [text, setText] = useState<string>('')

  const handleProcessingStart = useCallback(async () => {
    setStage('processing')

    const token = user ? await user.getIdToken() : undefined

    const data = await createGenerationRequest(deviceId, text, token)
    const requestId = data.request.id

    const poll = await pollRequest(deviceId, requestId)
    setProcessedImageUrl(poll.assets[0].url)
    setStage('finish')
  }, [deviceId, text, user])

  useEffect(() => {
    // Сброс данных, если пользователь вернулся на главный экран
    if (stage !== 'idle') return
    setText('')
    setProcessedImageUrl(null)
  }, [stage])

  useEffect(() => {
    // Изменение допустимых touch-action
    document.documentElement.style.setProperty('--touch-action', 'none')

    return () => {
      document.documentElement.style.setProperty('--touch-action', 'pan-y')
    }
  }, [])

  return (
    <div className={c.main}>
      <Container flex fullHeight fluid={stage === 'finish'}>
        {stage === 'idle' && (
          <IdleStage
            text={text}
            onTextChange={setText}
            onProcessingStart={handleProcessingStart}
          />
        )}
        {stage === 'processing' && <ProcessingStage />}
        {stage === 'finish' && (
          <FinishStage
            text={text}
            processedImageUrl={processedImageUrl!}
            onGenerateMore={handleProcessingStart}
          />
        )}
      </Container>
    </div>
  )
}

export default GenerationPage
